/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root';
import { Route as VerificationImport } from './routes/verification';
import { Route as TasksImport } from './routes/tasks';
import { Route as SignUpImport } from './routes/sign-up';
import { Route as PremiumImport } from './routes/premium';
import { Route as LikesImport } from './routes/likes';
import { Route as IndexImport } from './routes/index';
import { Route as ProfileIndexImport } from './routes/profile/index';
import { Route as InviteIndexImport } from './routes/invite/index';
import { Route as DatingIndexImport } from './routes/dating/index';
import { Route as ChatsIndexImport } from './routes/chats/index';
import { Route as ProfilePaymentsImport } from './routes/profile/payments';
import { Route as MatchmakerRecommendationsImport } from './routes/matchmaker/recommendations';
import { Route as MatchmakerFriendImport } from './routes/matchmaker/friend';
import { Route as InviteCandidateImport } from './routes/invite/candidate';
import { Route as DatingReportImport } from './routes/dating/report';
import { Route as DatingFiltersImport } from './routes/dating/filters';
import { Route as ChatsMatchIdImport } from './routes/chats/$matchId';
import { Route as ProfileSettingsIndexImport } from './routes/profile/settings/index';
import { Route as ProfileEditIndexImport } from './routes/profile/edit/index';
import { Route as ProfileSettingsNotificationsImport } from './routes/profile/settings/notifications';
import { Route as ProfileEditStudyAndWorkImport } from './routes/profile/edit/study-and-work';
import { Route as ProfileEditShortImport } from './routes/profile/edit/short';
import { Route as ProfileEditInterestsImport } from './routes/profile/edit/interests';
import { Route as DatingProfileProfileIdImport } from './routes/dating/profile.$profileId';

// Create/Update Routes

const VerificationRoute = VerificationImport.update({
  id: '/verification',
  path: '/verification',
  getParentRoute: () => rootRoute,
} as any);

const TasksRoute = TasksImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => rootRoute,
} as any);

const SignUpRoute = SignUpImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRoute,
} as any);

const PremiumRoute = PremiumImport.update({
  id: '/premium',
  path: '/premium',
  getParentRoute: () => rootRoute,
} as any);

const LikesRoute = LikesImport.update({
  id: '/likes',
  path: '/likes',
  getParentRoute: () => rootRoute,
} as any);

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any);

const ProfileIndexRoute = ProfileIndexImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => rootRoute,
} as any);

const InviteIndexRoute = InviteIndexImport.update({
  id: '/invite/',
  path: '/invite/',
  getParentRoute: () => rootRoute,
} as any);

const DatingIndexRoute = DatingIndexImport.update({
  id: '/dating/',
  path: '/dating/',
  getParentRoute: () => rootRoute,
} as any);

const ChatsIndexRoute = ChatsIndexImport.update({
  id: '/chats/',
  path: '/chats/',
  getParentRoute: () => rootRoute,
} as any);

const ProfilePaymentsRoute = ProfilePaymentsImport.update({
  id: '/profile/payments',
  path: '/profile/payments',
  getParentRoute: () => rootRoute,
} as any);

const MatchmakerRecommendationsRoute = MatchmakerRecommendationsImport.update({
  id: '/matchmaker/recommendations',
  path: '/matchmaker/recommendations',
  getParentRoute: () => rootRoute,
} as any);

const MatchmakerFriendRoute = MatchmakerFriendImport.update({
  id: '/matchmaker/friend',
  path: '/matchmaker/friend',
  getParentRoute: () => rootRoute,
} as any);

const InviteCandidateRoute = InviteCandidateImport.update({
  id: '/invite/candidate',
  path: '/invite/candidate',
  getParentRoute: () => rootRoute,
} as any);

const DatingReportRoute = DatingReportImport.update({
  id: '/dating/report',
  path: '/dating/report',
  getParentRoute: () => rootRoute,
} as any);

const DatingFiltersRoute = DatingFiltersImport.update({
  id: '/dating/filters',
  path: '/dating/filters',
  getParentRoute: () => rootRoute,
} as any);

const ChatsMatchIdRoute = ChatsMatchIdImport.update({
  id: '/chats/$matchId',
  path: '/chats/$matchId',
  getParentRoute: () => rootRoute,
} as any);

const ProfileSettingsIndexRoute = ProfileSettingsIndexImport.update({
  id: '/profile/settings/',
  path: '/profile/settings/',
  getParentRoute: () => rootRoute,
} as any);

const ProfileEditIndexRoute = ProfileEditIndexImport.update({
  id: '/profile/edit/',
  path: '/profile/edit/',
  getParentRoute: () => rootRoute,
} as any);

const ProfileSettingsNotificationsRoute =
  ProfileSettingsNotificationsImport.update({
    id: '/profile/settings/notifications',
    path: '/profile/settings/notifications',
    getParentRoute: () => rootRoute,
  } as any);

const ProfileEditStudyAndWorkRoute = ProfileEditStudyAndWorkImport.update({
  id: '/profile/edit/study-and-work',
  path: '/profile/edit/study-and-work',
  getParentRoute: () => rootRoute,
} as any);

const ProfileEditShortRoute = ProfileEditShortImport.update({
  id: '/profile/edit/short',
  path: '/profile/edit/short',
  getParentRoute: () => rootRoute,
} as any);

const ProfileEditInterestsRoute = ProfileEditInterestsImport.update({
  id: '/profile/edit/interests',
  path: '/profile/edit/interests',
  getParentRoute: () => rootRoute,
} as any);

const DatingProfileProfileIdRoute = DatingProfileProfileIdImport.update({
  id: '/dating/profile/$profileId',
  path: '/dating/profile/$profileId',
  getParentRoute: () => rootRoute,
} as any);

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexImport;
      parentRoute: typeof rootRoute;
    };
    '/likes': {
      id: '/likes';
      path: '/likes';
      fullPath: '/likes';
      preLoaderRoute: typeof LikesImport;
      parentRoute: typeof rootRoute;
    };
    '/premium': {
      id: '/premium';
      path: '/premium';
      fullPath: '/premium';
      preLoaderRoute: typeof PremiumImport;
      parentRoute: typeof rootRoute;
    };
    '/sign-up': {
      id: '/sign-up';
      path: '/sign-up';
      fullPath: '/sign-up';
      preLoaderRoute: typeof SignUpImport;
      parentRoute: typeof rootRoute;
    };
    '/tasks': {
      id: '/tasks';
      path: '/tasks';
      fullPath: '/tasks';
      preLoaderRoute: typeof TasksImport;
      parentRoute: typeof rootRoute;
    };
    '/verification': {
      id: '/verification';
      path: '/verification';
      fullPath: '/verification';
      preLoaderRoute: typeof VerificationImport;
      parentRoute: typeof rootRoute;
    };
    '/chats/$matchId': {
      id: '/chats/$matchId';
      path: '/chats/$matchId';
      fullPath: '/chats/$matchId';
      preLoaderRoute: typeof ChatsMatchIdImport;
      parentRoute: typeof rootRoute;
    };
    '/dating/filters': {
      id: '/dating/filters';
      path: '/dating/filters';
      fullPath: '/dating/filters';
      preLoaderRoute: typeof DatingFiltersImport;
      parentRoute: typeof rootRoute;
    };
    '/dating/report': {
      id: '/dating/report';
      path: '/dating/report';
      fullPath: '/dating/report';
      preLoaderRoute: typeof DatingReportImport;
      parentRoute: typeof rootRoute;
    };
    '/invite/candidate': {
      id: '/invite/candidate';
      path: '/invite/candidate';
      fullPath: '/invite/candidate';
      preLoaderRoute: typeof InviteCandidateImport;
      parentRoute: typeof rootRoute;
    };
    '/matchmaker/friend': {
      id: '/matchmaker/friend';
      path: '/matchmaker/friend';
      fullPath: '/matchmaker/friend';
      preLoaderRoute: typeof MatchmakerFriendImport;
      parentRoute: typeof rootRoute;
    };
    '/matchmaker/recommendations': {
      id: '/matchmaker/recommendations';
      path: '/matchmaker/recommendations';
      fullPath: '/matchmaker/recommendations';
      preLoaderRoute: typeof MatchmakerRecommendationsImport;
      parentRoute: typeof rootRoute;
    };
    '/profile/payments': {
      id: '/profile/payments';
      path: '/profile/payments';
      fullPath: '/profile/payments';
      preLoaderRoute: typeof ProfilePaymentsImport;
      parentRoute: typeof rootRoute;
    };
    '/chats/': {
      id: '/chats/';
      path: '/chats';
      fullPath: '/chats';
      preLoaderRoute: typeof ChatsIndexImport;
      parentRoute: typeof rootRoute;
    };
    '/dating/': {
      id: '/dating/';
      path: '/dating';
      fullPath: '/dating';
      preLoaderRoute: typeof DatingIndexImport;
      parentRoute: typeof rootRoute;
    };
    '/invite/': {
      id: '/invite/';
      path: '/invite';
      fullPath: '/invite';
      preLoaderRoute: typeof InviteIndexImport;
      parentRoute: typeof rootRoute;
    };
    '/profile/': {
      id: '/profile/';
      path: '/profile';
      fullPath: '/profile';
      preLoaderRoute: typeof ProfileIndexImport;
      parentRoute: typeof rootRoute;
    };
    '/dating/profile/$profileId': {
      id: '/dating/profile/$profileId';
      path: '/dating/profile/$profileId';
      fullPath: '/dating/profile/$profileId';
      preLoaderRoute: typeof DatingProfileProfileIdImport;
      parentRoute: typeof rootRoute;
    };
    '/profile/edit/interests': {
      id: '/profile/edit/interests';
      path: '/profile/edit/interests';
      fullPath: '/profile/edit/interests';
      preLoaderRoute: typeof ProfileEditInterestsImport;
      parentRoute: typeof rootRoute;
    };
    '/profile/edit/short': {
      id: '/profile/edit/short';
      path: '/profile/edit/short';
      fullPath: '/profile/edit/short';
      preLoaderRoute: typeof ProfileEditShortImport;
      parentRoute: typeof rootRoute;
    };
    '/profile/edit/study-and-work': {
      id: '/profile/edit/study-and-work';
      path: '/profile/edit/study-and-work';
      fullPath: '/profile/edit/study-and-work';
      preLoaderRoute: typeof ProfileEditStudyAndWorkImport;
      parentRoute: typeof rootRoute;
    };
    '/profile/settings/notifications': {
      id: '/profile/settings/notifications';
      path: '/profile/settings/notifications';
      fullPath: '/profile/settings/notifications';
      preLoaderRoute: typeof ProfileSettingsNotificationsImport;
      parentRoute: typeof rootRoute;
    };
    '/profile/edit/': {
      id: '/profile/edit/';
      path: '/profile/edit';
      fullPath: '/profile/edit';
      preLoaderRoute: typeof ProfileEditIndexImport;
      parentRoute: typeof rootRoute;
    };
    '/profile/settings/': {
      id: '/profile/settings/';
      path: '/profile/settings';
      fullPath: '/profile/settings';
      preLoaderRoute: typeof ProfileSettingsIndexImport;
      parentRoute: typeof rootRoute;
    };
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/likes': typeof LikesRoute;
  '/premium': typeof PremiumRoute;
  '/sign-up': typeof SignUpRoute;
  '/tasks': typeof TasksRoute;
  '/verification': typeof VerificationRoute;
  '/chats/$matchId': typeof ChatsMatchIdRoute;
  '/dating/filters': typeof DatingFiltersRoute;
  '/dating/report': typeof DatingReportRoute;
  '/invite/candidate': typeof InviteCandidateRoute;
  '/matchmaker/friend': typeof MatchmakerFriendRoute;
  '/matchmaker/recommendations': typeof MatchmakerRecommendationsRoute;
  '/profile/payments': typeof ProfilePaymentsRoute;
  '/chats': typeof ChatsIndexRoute;
  '/dating': typeof DatingIndexRoute;
  '/invite': typeof InviteIndexRoute;
  '/profile': typeof ProfileIndexRoute;
  '/dating/profile/$profileId': typeof DatingProfileProfileIdRoute;
  '/profile/edit/interests': typeof ProfileEditInterestsRoute;
  '/profile/edit/short': typeof ProfileEditShortRoute;
  '/profile/edit/study-and-work': typeof ProfileEditStudyAndWorkRoute;
  '/profile/settings/notifications': typeof ProfileSettingsNotificationsRoute;
  '/profile/edit': typeof ProfileEditIndexRoute;
  '/profile/settings': typeof ProfileSettingsIndexRoute;
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/likes': typeof LikesRoute;
  '/premium': typeof PremiumRoute;
  '/sign-up': typeof SignUpRoute;
  '/tasks': typeof TasksRoute;
  '/verification': typeof VerificationRoute;
  '/chats/$matchId': typeof ChatsMatchIdRoute;
  '/dating/filters': typeof DatingFiltersRoute;
  '/dating/report': typeof DatingReportRoute;
  '/invite/candidate': typeof InviteCandidateRoute;
  '/matchmaker/friend': typeof MatchmakerFriendRoute;
  '/matchmaker/recommendations': typeof MatchmakerRecommendationsRoute;
  '/profile/payments': typeof ProfilePaymentsRoute;
  '/chats': typeof ChatsIndexRoute;
  '/dating': typeof DatingIndexRoute;
  '/invite': typeof InviteIndexRoute;
  '/profile': typeof ProfileIndexRoute;
  '/dating/profile/$profileId': typeof DatingProfileProfileIdRoute;
  '/profile/edit/interests': typeof ProfileEditInterestsRoute;
  '/profile/edit/short': typeof ProfileEditShortRoute;
  '/profile/edit/study-and-work': typeof ProfileEditStudyAndWorkRoute;
  '/profile/settings/notifications': typeof ProfileSettingsNotificationsRoute;
  '/profile/edit': typeof ProfileEditIndexRoute;
  '/profile/settings': typeof ProfileSettingsIndexRoute;
}

export interface FileRoutesById {
  __root__: typeof rootRoute;
  '/': typeof IndexRoute;
  '/likes': typeof LikesRoute;
  '/premium': typeof PremiumRoute;
  '/sign-up': typeof SignUpRoute;
  '/tasks': typeof TasksRoute;
  '/verification': typeof VerificationRoute;
  '/chats/$matchId': typeof ChatsMatchIdRoute;
  '/dating/filters': typeof DatingFiltersRoute;
  '/dating/report': typeof DatingReportRoute;
  '/invite/candidate': typeof InviteCandidateRoute;
  '/matchmaker/friend': typeof MatchmakerFriendRoute;
  '/matchmaker/recommendations': typeof MatchmakerRecommendationsRoute;
  '/profile/payments': typeof ProfilePaymentsRoute;
  '/chats/': typeof ChatsIndexRoute;
  '/dating/': typeof DatingIndexRoute;
  '/invite/': typeof InviteIndexRoute;
  '/profile/': typeof ProfileIndexRoute;
  '/dating/profile/$profileId': typeof DatingProfileProfileIdRoute;
  '/profile/edit/interests': typeof ProfileEditInterestsRoute;
  '/profile/edit/short': typeof ProfileEditShortRoute;
  '/profile/edit/study-and-work': typeof ProfileEditStudyAndWorkRoute;
  '/profile/settings/notifications': typeof ProfileSettingsNotificationsRoute;
  '/profile/edit/': typeof ProfileEditIndexRoute;
  '/profile/settings/': typeof ProfileSettingsIndexRoute;
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/likes'
    | '/premium'
    | '/sign-up'
    | '/tasks'
    | '/verification'
    | '/chats/$matchId'
    | '/dating/filters'
    | '/dating/report'
    | '/invite/candidate'
    | '/matchmaker/friend'
    | '/matchmaker/recommendations'
    | '/profile/payments'
    | '/chats'
    | '/dating'
    | '/invite'
    | '/profile'
    | '/dating/profile/$profileId'
    | '/profile/edit/interests'
    | '/profile/edit/short'
    | '/profile/edit/study-and-work'
    | '/profile/settings/notifications'
    | '/profile/edit'
    | '/profile/settings';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/likes'
    | '/premium'
    | '/sign-up'
    | '/tasks'
    | '/verification'
    | '/chats/$matchId'
    | '/dating/filters'
    | '/dating/report'
    | '/invite/candidate'
    | '/matchmaker/friend'
    | '/matchmaker/recommendations'
    | '/profile/payments'
    | '/chats'
    | '/dating'
    | '/invite'
    | '/profile'
    | '/dating/profile/$profileId'
    | '/profile/edit/interests'
    | '/profile/edit/short'
    | '/profile/edit/study-and-work'
    | '/profile/settings/notifications'
    | '/profile/edit'
    | '/profile/settings';
  id:
    | '__root__'
    | '/'
    | '/likes'
    | '/premium'
    | '/sign-up'
    | '/tasks'
    | '/verification'
    | '/chats/$matchId'
    | '/dating/filters'
    | '/dating/report'
    | '/invite/candidate'
    | '/matchmaker/friend'
    | '/matchmaker/recommendations'
    | '/profile/payments'
    | '/chats/'
    | '/dating/'
    | '/invite/'
    | '/profile/'
    | '/dating/profile/$profileId'
    | '/profile/edit/interests'
    | '/profile/edit/short'
    | '/profile/edit/study-and-work'
    | '/profile/settings/notifications'
    | '/profile/edit/'
    | '/profile/settings/';
  fileRoutesById: FileRoutesById;
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  LikesRoute: typeof LikesRoute;
  PremiumRoute: typeof PremiumRoute;
  SignUpRoute: typeof SignUpRoute;
  TasksRoute: typeof TasksRoute;
  VerificationRoute: typeof VerificationRoute;
  ChatsMatchIdRoute: typeof ChatsMatchIdRoute;
  DatingFiltersRoute: typeof DatingFiltersRoute;
  DatingReportRoute: typeof DatingReportRoute;
  InviteCandidateRoute: typeof InviteCandidateRoute;
  MatchmakerFriendRoute: typeof MatchmakerFriendRoute;
  MatchmakerRecommendationsRoute: typeof MatchmakerRecommendationsRoute;
  ProfilePaymentsRoute: typeof ProfilePaymentsRoute;
  ChatsIndexRoute: typeof ChatsIndexRoute;
  DatingIndexRoute: typeof DatingIndexRoute;
  InviteIndexRoute: typeof InviteIndexRoute;
  ProfileIndexRoute: typeof ProfileIndexRoute;
  DatingProfileProfileIdRoute: typeof DatingProfileProfileIdRoute;
  ProfileEditInterestsRoute: typeof ProfileEditInterestsRoute;
  ProfileEditShortRoute: typeof ProfileEditShortRoute;
  ProfileEditStudyAndWorkRoute: typeof ProfileEditStudyAndWorkRoute;
  ProfileSettingsNotificationsRoute: typeof ProfileSettingsNotificationsRoute;
  ProfileEditIndexRoute: typeof ProfileEditIndexRoute;
  ProfileSettingsIndexRoute: typeof ProfileSettingsIndexRoute;
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LikesRoute: LikesRoute,
  PremiumRoute: PremiumRoute,
  SignUpRoute: SignUpRoute,
  TasksRoute: TasksRoute,
  VerificationRoute: VerificationRoute,
  ChatsMatchIdRoute: ChatsMatchIdRoute,
  DatingFiltersRoute: DatingFiltersRoute,
  DatingReportRoute: DatingReportRoute,
  InviteCandidateRoute: InviteCandidateRoute,
  MatchmakerFriendRoute: MatchmakerFriendRoute,
  MatchmakerRecommendationsRoute: MatchmakerRecommendationsRoute,
  ProfilePaymentsRoute: ProfilePaymentsRoute,
  ChatsIndexRoute: ChatsIndexRoute,
  DatingIndexRoute: DatingIndexRoute,
  InviteIndexRoute: InviteIndexRoute,
  ProfileIndexRoute: ProfileIndexRoute,
  DatingProfileProfileIdRoute: DatingProfileProfileIdRoute,
  ProfileEditInterestsRoute: ProfileEditInterestsRoute,
  ProfileEditShortRoute: ProfileEditShortRoute,
  ProfileEditStudyAndWorkRoute: ProfileEditStudyAndWorkRoute,
  ProfileSettingsNotificationsRoute: ProfileSettingsNotificationsRoute,
  ProfileEditIndexRoute: ProfileEditIndexRoute,
  ProfileSettingsIndexRoute: ProfileSettingsIndexRoute,
};

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/likes",
        "/premium",
        "/sign-up",
        "/tasks",
        "/verification",
        "/chats/$matchId",
        "/dating/filters",
        "/dating/report",
        "/invite/candidate",
        "/matchmaker/friend",
        "/matchmaker/recommendations",
        "/profile/payments",
        "/chats/",
        "/dating/",
        "/invite/",
        "/profile/",
        "/dating/profile/$profileId",
        "/profile/edit/interests",
        "/profile/edit/short",
        "/profile/edit/study-and-work",
        "/profile/settings/notifications",
        "/profile/edit/",
        "/profile/settings/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/likes": {
      "filePath": "likes.tsx"
    },
    "/premium": {
      "filePath": "premium.tsx"
    },
    "/sign-up": {
      "filePath": "sign-up.tsx"
    },
    "/tasks": {
      "filePath": "tasks.tsx"
    },
    "/verification": {
      "filePath": "verification.tsx"
    },
    "/chats/$matchId": {
      "filePath": "chats/$matchId.tsx"
    },
    "/dating/filters": {
      "filePath": "dating/filters.tsx"
    },
    "/dating/report": {
      "filePath": "dating/report.tsx"
    },
    "/invite/candidate": {
      "filePath": "invite/candidate.tsx"
    },
    "/matchmaker/friend": {
      "filePath": "matchmaker/friend.tsx"
    },
    "/matchmaker/recommendations": {
      "filePath": "matchmaker/recommendations.tsx"
    },
    "/profile/payments": {
      "filePath": "profile/payments.tsx"
    },
    "/chats/": {
      "filePath": "chats/index.tsx"
    },
    "/dating/": {
      "filePath": "dating/index.tsx"
    },
    "/invite/": {
      "filePath": "invite/index.tsx"
    },
    "/profile/": {
      "filePath": "profile/index.tsx"
    },
    "/dating/profile/$profileId": {
      "filePath": "dating/profile.$profileId.tsx"
    },
    "/profile/edit/interests": {
      "filePath": "profile/edit/interests.tsx"
    },
    "/profile/edit/short": {
      "filePath": "profile/edit/short.tsx"
    },
    "/profile/edit/study-and-work": {
      "filePath": "profile/edit/study-and-work.tsx"
    },
    "/profile/settings/notifications": {
      "filePath": "profile/settings/notifications.tsx"
    },
    "/profile/edit/": {
      "filePath": "profile/edit/index.tsx"
    },
    "/profile/settings/": {
      "filePath": "profile/settings/index.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
